
import React, { Component } from 'react'
import axios from 'axios'


const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
const token = localStorage.getItem("token");
const type = localStorage.getItem("type");
class UploadImage extends Component {
	constructor(props) {
		super(props)

	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()

		const formData = new FormData();
		const imagefile = document.querySelector('#imagefile');
		formData.append("image", imagefile.files[0]);
		console.log(this.state)
		axios
			.put(`https://shoppee-clone.herokuapp.com/upload/${id}/`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
			.then(response => {
				// ALERT
				console.log(response)

				window.location.reload("/products");
			})
			.catch(error => {
				alert("error")
				console.log(error)
			})
	}

	render() {
		if (type === "boss" && token != null) {
			return (
				<div>
					<div className="custom-file">
						<form onSubmit={this.submitHandler} encType="multipart/form-data">
						<label className="custom-file-label d-flex justify-content-around"  htmlFor="customFile"><h3>Insert Image for Product</h3></label>
							<input type="file" className="custom-file-input" id="imagefile" />
							<div className="mt-4 d-flex justify-content-around">
								<button type="submit" className="px-sm-5 mb-5 px-3 py-2 btn btn-dark">Submit</button>
							</div>
						</form></div></div>
	
	
			)
		}
		
	}
}

export default UploadImage

